<template>
  <v-form ref="form" @submit.prevent="submit">
    <div class="stepAgreement">
      <v-row class="buttonBack mb-5 ml-9 pt-3">
        <QuotationBackButton @back="previousStep" />
        <v-spacer />
      </v-row>
      <v-row>
        <v-spacer />
        <QuotationFloatActionButton
          class="messageInfoAgreement"
          v-if="!getIsEmployeeUser"
          :message="infoMessage"
        />
      </v-row>
      <QuotationAgreementForm
        class="mt-6"
        @submit="submit"
        v-model="form"
        :form="form"
        :product="product"
        :options-quotation="optionsQuotation"
      />
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col
            cols="12"
            sm="5"
            md="3"
            class="pr-0 pr-sm-5 pb-5 pb-sm-0"
            v-if="allowNextStep"
          >
            <BaseButton
              v-html="'PRÓXIMO'"
              class="white--text secondary"
              width="100%"
              @click="submit()"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </div>
  </v-form>
</template>
<script>
import QuotationAgreementForm from "../components_agro/QuotationAgreementForm.vue";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { mapActions, mapState } from "vuex";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";

export default {
  name: "QuotationStepAgreement",
  components: {
    QuotationAgreementForm,
    QuotationBackButton,
    QuotationFloatActionButton
  },
  mixins: [QuotationMixin],
  created() {},
  data: () => ({}),
  computed: {
    ...mapState("me", ["userIsEmployee"]),
    nextQuotationStep() {
      return {
        name: "quotation step policy",
        step: 10
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step proposal",
        step: 8
      };
    },
    allowNextStep() {
      return (
        !(this.form.cards.filter(x => x.status.id != "aprovado").length > 0) &&
        this.form.cards.length > 0
      );
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return (
        "Insira os documentos solicitados. Faremos a análise e a indicaremos aqui se estão OK ou não." +
        " Em caso de reprovação, colocaremos a justificativa. Neste caso, será necessário corrigir e reenviar o documento. Quando todos estiverem aprovados, o botão de Próximo irá ficar disponível. "
      );
    }
  },
  methods: {
    getFormForNavigation() {
      return this.form;
    },
    ...mapActions(["showAlertNotification"]),
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.form, this.previousQuotationStep)
      );
    },
    submit() {
      if (!this.allowNextStep) {
        this.showAlertNotification({
          message: "É necessário que todos os documentos estejam aprovados.",
          type: "error"
        });
        return;
      }
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.form, this.nextQuotationStep)
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    product: {
      type: String
    }
  }
};
</script>

<style lang="sass">
.stepAgreement
  width: 90% !important
  margin: 0 auto !important
.buttonBack
  margin-top: -30px !important
  margin-bottom: 8px
.messageInfoAgreement
  margin-top: -68px
  margin-right: 90px
</style>
